import {
  Alert,
  Box,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@shared/ui';
import { useState } from 'react';
import { useGetCalendarChangeAggregateQuery } from './api/adminCalendarChangesApi';

const dateInputValue = (date: Date) => date.toISOString().slice(0, 10);

export function AdminCalendarChangeAggregate() {
  const [rangeExplicit, setRangeExplicit] = useState(false);
  const [to, setTo] = useState(() => dateInputValue(new Date()));
  const [from, setFrom] = useState(() => {
    const date = new Date();
    date.setUTCDate(date.getUTCDate() - 30);
    return dateInputValue(date);
  });
  const { data, error, isLoading } = useGetCalendarChangeAggregateQuery(
    rangeExplicit
      ? {
          from: from ? `${from}T00:00:00Z` : undefined,
          to: to ? `${to}T23:59:59.999999999Z` : undefined,
        }
      : undefined
  );

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          gap: 1.5,
          alignItems: { sm: 'center' },
        }}
      >
        <Typography component="h2" variant="h6" sx={{ flexGrow: 1 }}>
          Rescheduling by coach
        </Typography>
        <TextField
          label="From"
          type="date"
          value={from}
          onChange={(event) => {
            setFrom(event.target.value);
            setRangeExplicit(true);
          }}
          size="small"
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          label="To"
          type="date"
          value={to}
          onChange={(event) => {
            setTo(event.target.value);
            setRangeExplicit(true);
          }}
          size="small"
          InputLabelProps={{ shrink: true }}
        />
      </Box>
      <Typography color="text.secondary" variant="body2">
        Counts are operation-level and directional, not a like-for-like ratio: one Google series
        change may affect multiple appointments.
      </Typography>
      {error && <Alert severity="error">Could not load rescheduling counts.</Alert>}
      {isLoading ? (
        <CircularProgress size={24} />
      ) : (
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Coach</TableCell>
                <TableCell align="right">Google-originated</TableCell>
                <TableCell align="right">Platform-originated</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.coaches.map((coach) => (
                <TableRow key={coach.coach_person_id}>
                  <TableCell>{coach.coach_person_id}</TableCell>
                  <TableCell align="right">{coach.google_originated}</TableCell>
                  <TableCell align="right">{coach.platform_originated}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}
